<template>
  <div class="popup-wrapper sifrarnik release-notes">
    <!-- <DataLoader :is_on="false" /> -->
    <div class="sifrarnik-radnje-title"><span>{{$t('components.version_popup.version_title')}}</span>
      <a @click="closePopup()" class="popup-close-icon-wrapper"><img src="@/assets/img/entry_form_close.svg" /></a>
    </div>
    <div class="radnje-content">
      <div class="radnje-main-wrapper">
        <release-note v-for="(note,key) in release_notes" :key="key" :note="note" :is_latest="key == 0" @editNote="editNote(note)" @deleteNote="deleteNote(note)"></release-note>
      </div>
    </div>
    <div class="add-radnja" @click="openAddNew()">
      {{$t('components.version_popup.add_new_version')}}
    </div>
    <v-dialog v-model="new_release_dialog " width="800px">
      <v-card class="version-unos" color="universal-vcard">
          <div class="universal-vdialog-title">
              {{!is_edit_mode ? $t('components.version_popup.edit_title1') : $t('components.version_popup.edit_title2')}}
          </div>
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{$t('components.version_popup.version')}}</span>
            </label>
            <div class="version-inputs">
              <input type="number" v-model="release_note.version.sub_v1"/>.<input type="number" v-model="release_note.version.sub_v2"/>.<input type="number" v-model="release_note.version.sub_v3"/>
            </div>
          </div>
          <div class="sifra-opis-wrapper">
            <label class="form-label">
              <span>{{$t('components.version_popup.details')}}</span>
            </label>
            <ckeditor :editor="editor" v-model="release_note.details" :config="editorConfig"></ckeditor>
          </div>
          <div class="vdialog-buttons-wrapper">
              <div class="universal-vdialog-button vbutton-secondary" @click="setInitialValues();">
                {{ $t("repetitive.cancel") }}
              </div>
              <div class="universal-vdialog-button vbutton-primary" @click="addEditReleaseNote();"> {{$t('components.version_popup.save')}}
              </div>
          </div>
        </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" width="564px">
        <v-card color="universal-vcard">
            <div class="universal-vdialog-title">
              {{$t('components.version_popup.delete_title')}} {{release_note.version}}
            </div>
            <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                <div class="universal-vdialog-button vbutton-secondary" @click="delete_dialog = false">
                  {{ $t("repetitive.cancel") }} </div>
                <div class="universal-vdialog-button vbutton-primary" @click="finishDelete()">
                  {{$t('components.version_popup.delete')}} </div>
            </div>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReleaseNote from './ReleaseNote.vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@/plugins/ckeditor_build';
import gsap from 'gsap';
import admin from "@/apiCallers/promise_handler_db/admin";

export default {
    components: { 
      ReleaseNote, 
      ckeditor: CKEditor.component 
    },
    props:['release_notes'],
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'link',
                        '|',
                        'undo',
                        'redo',
                        '|',
                        'bulletedList', 
                        'numberedList',
                        'texttransform'
                    ]
                },
                link: {
                    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
                    addTargetToExternalLinks: true,
                }
            },
            new_release_dialog:false,
            release_note:{
              uid:null,
              version:{
                sub_v1:0,
                sub_v2:0,
                sub_v3:0,
              },
              details:this.$t('components.version_popup.init_details'),
            },
            is_edit_mode:false,
            delete_dialog:false,
        }
    },
    methods: {
        closePopup(){
            this.$emit('closeReleaseNotes')
        },
        deleteNote(note){
          this.release_note.uid = note.uid;
          this.release_note.version = note.version;
          this.delete_dialog = true;
        },
        async finishDelete(){
          await admin.deleteReleaseNote(this.release_note.uid).then((resp)=>{
              this.delete_dialog = false;
              this.setInitialValues();
              this.$emit('reloadNotes');
            });
        },
        editNote(note){
          this.is_edit_mode = true;
          const last_version_splitted = note.version.split('.');
          this.release_note = {
            uid:note.uid,
            version:{
                sub_v1:parseInt(last_version_splitted[0]),
                sub_v2:parseInt(last_version_splitted[1]),
                sub_v3:parseInt(last_version_splitted[2]),
              },
            details:note.details,
          }
          this.new_release_dialog = true;
          setTimeout(() => {
              gsap.to('.sifra-opis-wrapper',1,{width:'99%'})
              gsap.to('.sifra-opis-wrapper',1,{width:'100%'})
          }, 100);
        },
        openAddNew(){
          const last_version_splitted = this.release_notes[0].version.split('.');
          this.release_note.version.sub_v1 = parseInt(last_version_splitted[0]);
          this.release_note.version.sub_v2 = parseInt(last_version_splitted[1]);
          this.release_note.version.sub_v3 = parseInt(last_version_splitted[2])+1;
          this.new_release_dialog = true;
          setTimeout(() => {
              gsap.to('.sifra-opis-wrapper',1,{width:'99%'})
              gsap.to('.sifra-opis-wrapper',1,{width:'100%'})
          }, 100);
        },
        async addEditReleaseNote(){
          const final_relese_note={
            uid: this.release_note.uid,
            version: `${this.release_note.version.sub_v1 != '' ? this.release_note.version.sub_v1 : '0'}.${this.release_note.version.sub_v2 != '' ? this.release_note.version.sub_v2 : '0'}.${this.release_note.version.sub_v3 != '' ? this.release_note.version.sub_v3 : '0'}`,
            details: this.release_note.details,
          };
          if (!this.is_edit_mode) {
            await admin.addNewReleaseNote(final_relese_note).then((resp)=>{
              this.setInitialValues();
              this.$emit('reloadNotes');
            });
          }
          else{
            await admin.editReleaseNote(final_relese_note).then((resp)=>{
            }).finally(()=>{
              this.setInitialValues();
              this.$emit('reloadNotes');
            });
          }
        },
        setInitialValues(){
          this.new_release_dialog=false;
          this.is_edit_mode=false;
          this.release_note={
            uid:null,
            version:{
              sub_v1:0,
              sub_v2:0,
              sub_v3:0,
            },
            details:this.$t('components.version_popup.init_details'),
          };
        }
    },
    mounted() {
      gsap.to(".mainH", 0.5, { overflow: "hidden" });
      gsap.to(".top", 0.5, {
        filter: "blur(5px)",
        opacity: 0.2,
        pointerEvents: "none"
      });
      gsap.to(".router-wrapper", 0.5, {
        filter: "blur(5px)",
        opacity: 0.2,
        pointerEvents: "none"
      });
      gsap.fromTo(
        ".popup-wrapper",
        0.5,
        { opacity: 0 },
        { zIndex: "999", opacity: 1 }
      );
    },
    beforeDestroy(){
      gsap.to(".popup-wrapper", 0.35, { opacity: 0 });
      gsap.to(".router-wrapper,.top", 0, { pointerEvents: "auto" });
      gsap.to(".mainH", 0, { overflow: "auto" });
      gsap.to(".router-wrapper,.top", 0.35, {
        filter: "none",
        opacity: 1,
      });
    }
}
</script>

<style>

</style>